import React from "react";
import LatestContent from "./components/LatestContent";
import "./content.style.css";
import { CONTENTS } from "./data";

const Content = () => {
  return (
    <section
      className="content"
      id="media_coverage"
      aria-labelledby="media-coverage-heading"
    >
      {/* Heading text unchanged, only semantic level fixed */}
      <h2 className="heading" id="media-coverage-heading">
        Recent Content
      </h2>

      {CONTENTS.map((content) => {
        return (
          <LatestContent
            content={content}
            key={content.id}
          />
        );
      })}
    </section>
  );
};

export default Content;
